import React from 'react';
import PropTypes from 'prop-types';

function ConversationContainer({ children }) {
  return (
    <div className="conversation-area">
      {children}
      <div className="overlay" />
    </div>
  );
}

ConversationContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConversationContainer;
